module.exports = __webpack_public_path__ + "static/media/Покана за свикване на ОСА на Формопласт АД, насрочено за 30 юни 2025 г..133a7a47.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2025/Покана за свикване на ОСА на Формопласт АД, насрочено за 30 юни 2025 г..pdf
// module id = 86
// module chunks = 0